module.exports = __webpack_public_path__ + "img/feature-index_4.59df3420.png";